import {
  postLogin,
  getUserInfo,
  getRequestLoginAccess,
  postRegisterUser,
  postIsAdmin,
  postIsUnilab,
  postAutomaticLogin
} from "./services";
import * as types from "./types";

export async function loginAction({ commit }, payload) {
  try {
    const { data } = await postLogin(payload);
    commit(types.SET_TOKEN, data);
  } catch (e) {
    console.log(e);
  }
}
export async function automaticLoginAction({ commit }) {
  try {
    const { data } = await postAutomaticLogin();
    commit(types.SET_TOKEN, data);
  } catch (e) {
    console.log(e);
  }
}


export async function userInfoAction({ commit }, payload) {
  try {
    const { data } = await getUserInfo(payload);
    commit(types.SET_USER_INFO, data);
  } catch (e) {
    console.log(e);
  }
}

export async function isAdminAction({ commit }) {
  try {
    const { data } = await postIsAdmin();
    commit(types.SET_IS_ADMIN, data);
  } catch (e) {
    console.log(e);
  }
}

export async function isUnilabAction({ commit }) {
  try {
    const { data } = await postIsUnilab();
    commit(types.SET_IS_UNILAB, data);
  } catch (e) {
    console.log(e);
  }
}
export async function isDebugAction({ commit }, payload) {
  try {
    commit(types.SET_IS_DEBUG, payload);
  } catch (e) {
    console.log(e);
  }
}

export async function loginRequestAccessAction(payload) {
  try {
    return await getRequestLoginAccess(payload);
  } catch (e) {
    console.log(e);
  }
}

export async function registerUserAction(payload) {
  try {
    return await postRegisterUser(payload);
  } catch (e) {
    console.log(e);
  }
}

export async function ShowTranslationsIdAction({ commit }) {
  try {
    commit(types.SHOW_TRANSLATION_ID);
  } catch (e) {
    console.log(e);
  }
}

export async function ShowEnglishToolTip({ commit }) {
  try {
    commit(types.SHOW_ENGLISH_TOOLTIP);
  } catch (e) {
    console.log(e);
  }
}
